import {Component, Inject} from '@angular/core';
import {Router} from '@angular/router';
import {AuthGuardService} from '../../services/auth-guard.service';
import {OnInit} from '@angular/core';
import {UserService} from '../../services/user.service';



@Component({
  selector: 'app-header',
  templateUrl: './header.html',
  styleUrls: ['./header.scss']
})
export class HeaderComponent implements OnInit {
  public logged: Boolean;
  public imageUrl: String;
  public username: String;
  public constructor(
      private auth: AuthGuardService, private user: UserService,
      private router: Router) {
    this.imageUrl = '';
    this.username = '';
  }

  ngOnInit() {
    this.auth.isLoggedIn().toPromise().then(res => {
      this.logged = res['logged'];
      if (res['logged']) {
        this.user.getUserProfile().subscribe(
            res => {
              if (res && res['profile']['image']) this.imageUrl = res['profile']['image'];
              this.username = res['username'];
            },
            err => { this.imageUrl = ''; });
      }
    });
  }

  logout() {
    this.user.logout().subscribe(
        res => { window.location.reload(); }, err => { console.log(err); });
  }
}


// WEBPACK FOOTER //
// ./src/app/components/header/header.ts